import React from 'react';
import classNames from 'classnames/bind';
import defaultImg from '../../assets/user/avatar-default-grey.png';
import style from './index.module.less';

const styles = classNames.bind(style);

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  size?: number;
  img?: string | null;
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

export const Avatar = (props: Props) => {
  const { size = 120, img = defaultImg, className, style, imgStyle, children, ...otherProps } = props;
  return (
    <div
      className={styles('avatar', className)}
      style={{ width: size, height: size, borderRadius: size / 2, ...style }}
      {...otherProps}>
      <div className={styles('img-wrapper')} style={{ backgroundImage: `url(${img})`, ...imgStyle }}></div>
      <div className={styles('avatar-slot')}>{children}</div>
    </div>
  );
};

export default Avatar;
